// THIS FILE IS AUTO-GENERATED. DO NOT EDIT DIRECTLY.
// Generated by generate-enums.ts

import { z } from 'zod';

export const OrganizationRoleSchema = z.enum([
  "OWNER",
  "ADMIN",
  "MEMBER",
  "VIEWER",
  "owner",
  "admin",
  "member"
]);
export type OrganizationRole = z.infer<typeof OrganizationRoleSchema>;

export const LanguageCodeSchema = z.enum([
  "EN",
  "ZH"
]);
export type LanguageCode = z.infer<typeof LanguageCodeSchema>;

export const ServiceAccountTypeSchema = z.enum([
  "COMPLIANCE_BOT",
  "INTEGRATION_BOT",
  "MONITORING_BOT"
]);
export type ServiceAccountType = z.infer<typeof ServiceAccountTypeSchema>;

export const TopicStatusSchema = z.enum([
  "Generating",
  "NotStarted",
  "InProgress",
  "Completed"
]);
export type TopicStatus = z.infer<typeof TopicStatusSchema>;

export const TopicTypeSchema = z.enum([
  "GUIDE",
  "SECTION",
  "GROUP",
  "CHANGELOG_SECTION",
  "CHANGELOG_INDEX",
  "CHANGELOG",
  "API_SECTION"
]);
export type TopicType = z.infer<typeof TopicTypeSchema>;

export const DocStatusSchema = z.enum([
  "Generating",
  "Pending",
  "Extracting",
  "Indexing",
  "Summarizing",
  "Completed",
  "Failed"
]);
export type DocStatus = z.infer<typeof DocStatusSchema>;

export const DocDifficultySchema = z.enum([
  "Beginner",
  "Intermediate",
  "Advanced"
]);
export type DocDifficulty = z.infer<typeof DocDifficultySchema>;

export const IconCategorySchema = z.enum([
  "EMOJI",
  "LUCIDE"
]);
export type IconCategory = z.infer<typeof IconCategorySchema>;

export const IconTypeSchema = z.enum([
  "REGULAR",
  "SOLID",
  "LIGHT",
  "THIN",
  "SHARP_SOLID",
  "DUOTONE",
  "BRANDS"
]);
export type IconType = z.infer<typeof IconTypeSchema>;

export const ShareAccessTypeSchema = z.enum([
  "Public",
  "Private",
  "EmailDomains",
  "Password"
]);
export type ShareAccessType = z.infer<typeof ShareAccessTypeSchema>;

export const WorkspaceRoleSchema = z.enum([
  "ADMIN",
  "COLLABORATOR",
  "VIEWER"
]);
export type WorkspaceRole = z.infer<typeof WorkspaceRoleSchema>;

export const ReaderAccessTypeSchema = z.enum([
  "DIRECT",
  "DOMAIN",
  "PUBLIC",
  "INVITE",
  "SHARE_LINK"
]);
export type ReaderAccessType = z.infer<typeof ReaderAccessTypeSchema>;

export const StepStatusSchema = z.enum([
  "Recorded",
  "IntentAnalyzed",
  "Analyzed",
  "Ignored"
]);
export type StepStatus = z.infer<typeof StepStatusSchema>;

export const StepTypeSchema = z.enum([
  "RecordingControl",
  "Step",
  "Navigation"
]);
export type StepType = z.infer<typeof StepTypeSchema>;

export const ActionTypeSchema = z.enum([
  "Click",
  "RightClick",
  "Hover",
  "Input",
  "Type",
  "Submit",
  "Scroll",
  "Navigation",
  "Highlight",
  "Screenshot",
  "StartRecording",
  "StopRecording",
  "PauseRecording",
  "ResumeRecording",
  "Unknown"
]);
export type ActionType = z.infer<typeof ActionTypeSchema>;

export const MountTypeSchema = z.enum([
  "GITHUB",
  "NOTION",
  "GOOGLE_DOCS",
  "CONFLUENCE"
]);
export type MountType = z.infer<typeof MountTypeSchema>;

export const HtmlSnapshotTypeSchema = z.enum([
  "Full",
  "Incremental"
]);
export type HtmlSnapshotType = z.infer<typeof HtmlSnapshotTypeSchema>;

export const MediaTypeSchema = z.enum([
  "VIDEO",
  "AUDIO"
]);
export type MediaType = z.infer<typeof MediaTypeSchema>;

export const VideoTypeSchema = z.enum([
  "SCREEN_RECORDING",
  "IMPORTED"
]);
export type VideoType = z.infer<typeof VideoTypeSchema>;

export const PlanSchema = z.enum([
  "FREE",
  "STARTER",
  "TEAM",
  "PRO",
  "ENTERPRISE",
  "CUSTOM"
]);
export type Plan = z.infer<typeof PlanSchema>;

export const ProductSchema = z.enum([
  "DEEPGUIDE",
  "SCREENATA",
  "GLYDE"
]);
export type Product = z.infer<typeof ProductSchema>;

export const SubscriptionStatusSchema = z.enum([
  "ACTIVE",
  "TRIALING",
  "PAST_DUE",
  "CANCELED",
  "INCOMPLETE",
  "PAUSED"
]);
export type SubscriptionStatus = z.infer<typeof SubscriptionStatusSchema>;

export const WorkspaceTypeSchema = z.enum([
  "DOCUMENTATION",
  "COMPLIANCE",
  "TRAINING",
  "SUPPORT",
  "API_DOCS",
  "RUNBOOKS",
  "SCREENATA"
]);
export type WorkspaceType = z.infer<typeof WorkspaceTypeSchema>;

export const WorkspaceFeatureSchema = z.enum([
  "COMPLIANCE_AUTOMATION",
  "API_DOCUMENTATION",
  "VIDEO_TUTORIALS",
  "KNOWLEDGE_BASE",
  "CHANGE_MANAGEMENT",
  "WORKFLOW_AUTOMATION"
]);
export type WorkspaceFeature = z.infer<typeof WorkspaceFeatureSchema>;

export const FlagCategorySchema = z.enum([
  "FEATURE",
  "EXPERIMENT",
  "OPERATIONAL",
  "PERMISSION"
]);
export type FlagCategory = z.infer<typeof FlagCategorySchema>;

export const EnvironmentSchema = z.enum([
  "DEVELOPMENT",
  "STAGING",
  "PRODUCTION"
]);
export type Environment = z.infer<typeof EnvironmentSchema>;

export const AuditActionSchema = z.enum([
  "CREATE",
  "UPDATE",
  "DELETE",
  "OVERRIDE",
  "ROLLBACK"
]);
export type AuditAction = z.infer<typeof AuditActionSchema>;

export const PurchaseStatusSchema = z.enum([
  "PENDING",
  "COMPLETED",
  "FAILED",
  "REFUNDED"
]);
export type PurchaseStatus = z.infer<typeof PurchaseStatusSchema>;

export const SeatChangeTypeSchema = z.enum([
  "ADDITION",
  "REMOVAL",
  "ADJUSTMENT"
]);
export type SeatChangeType = z.infer<typeof SeatChangeTypeSchema>;

export const TrialEventTypeSchema = z.enum([
  "TRIAL_STARTED",
  "TRIAL_REMINDER_SENT",
  "TRIAL_EXTENDED",
  "TRIAL_CONVERTED",
  "TRIAL_EXPIRED",
  "TRIAL_DOWNGRADED"
]);
export type TrialEventType = z.infer<typeof TrialEventTypeSchema>;

export const ActorTypeSchema = z.enum([
  "ADMIN",
  "USER",
  "SYSTEM"
]);
export type ActorType = z.infer<typeof ActorTypeSchema>;

export const ActionResultSchema = z.enum([
  "SUCCESS",
  "FAILURE"
]);
export type ActionResult = z.infer<typeof ActionResultSchema>;

export const SecuritySeveritySchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH",
  "CRITICAL"
]);
export type SecuritySeverity = z.infer<typeof SecuritySeveritySchema>;

export const SecurityEventTypeSchema = z.enum([
  "BRUTE_FORCE",
  "UNUSUAL_ACCESS",
  "DATA_EXPORT",
  "API_ABUSE",
  "RATE_LIMIT"
]);
export type SecurityEventType = z.infer<typeof SecurityEventTypeSchema>;

export const SecurityEventStatusSchema = z.enum([
  "OPEN",
  "INVESTIGATING",
  "RESOLVED",
  "FALSE_POSITIVE"
]);
export type SecurityEventStatus = z.infer<typeof SecurityEventStatusSchema>;

export const ImpersonationScopeSchema = z.enum([
  "READ",
  "FULL"
]);
export type ImpersonationScope = z.infer<typeof ImpersonationScopeSchema>;

export const DomainVerificationStatusSchema = z.enum([
  "PENDING",
  "VERIFIED",
  "FAILED"
]);
export type DomainVerificationStatus = z.infer<typeof DomainVerificationStatusSchema>;

export const DomainSSLStatusSchema = z.enum([
  "PENDING",
  "ACTIVE",
  "EXPIRED",
  "FAILED"
]);
export type DomainSSLStatus = z.infer<typeof DomainSSLStatusSchema>;

export const ChunkUploadStatusSchema = z.enum([
  "PENDING",
  "UPLOADING",
  "COMPLETED",
  "FAILED"
]);
export type ChunkUploadStatus = z.infer<typeof ChunkUploadStatusSchema>;

export const ChunkTranscriptStatusSchema = z.enum([
  "PENDING",
  "TRANSCRIBING",
  "COMPLETED",
  "FAILED"
]);
export type ChunkTranscriptStatus = z.infer<typeof ChunkTranscriptStatusSchema>;

export const SopStatusSchema = z.enum([
  "DRAFT",
  "PUBLISHED"
]);
export type SopStatus = z.infer<typeof SopStatusSchema>;

export const AppTypeSchema = z.enum([
  "AWS",
  "AZURE",
  "GCP",
  "OKTA",
  "AUTH0",
  "ONELOGIN",
  "JUMPCLOUD",
  "GITHUB",
  "GITLAB",
  "BITBUCKET",
  "JIRA",
  "CONFLUENCE",
  "GOOGLE_WORKSPACE",
  "MICROSOFT_365",
  "SLACK",
  "NOTION",
  "ZOOM",
  "STRIPE",
  "QUICKBOOKS",
  "BREX",
  "SALESFORCE",
  "HUBSPOT",
  "DATADOG",
  "SPLUNK",
  "CROWDSTRIKE",
  "SNYK",
  "WORKDAY",
  "BAMBOOHR",
  "RIPPLING",
  "GUSTO",
  "OTHER"
]);
export type AppType = z.infer<typeof AppTypeSchema>;

export const AssetTypeSchema = z.enum([
  "IMAGE",
  "VIDEO",
  "AUDIO",
  "DOCUMENT"
]);
export type AssetType = z.infer<typeof AssetTypeSchema>;

export const ChangeRequestStatusSchema = z.enum([
  "OPEN",
  "APPROVED",
  "MERGED",
  "CLOSED",
  "DRAFT"
]);
export type ChangeRequestStatus = z.infer<typeof ChangeRequestStatusSchema>;

export const CommentScopeSchema = z.enum([
  "INTERNAL",
  "PUBLIC"
]);
export type CommentScope = z.infer<typeof CommentScopeSchema>;

export const CommentTypeSchema = z.enum([
  "COMMENT",
  "SUGGESTION",
  "QUESTION",
  "ISSUE"
]);
export type CommentType = z.infer<typeof CommentTypeSchema>;

export const ComplianceFrameworkSchema = z.enum([
  "SOC2",
  "ISO27001",
  "HIPAA",
  "PCI_DSS",
  "GDPR",
  "NIST",
  "CUSTOM"
]);
export type ComplianceFramework = z.infer<typeof ComplianceFrameworkSchema>;

export const ConnectionStatusSchema = z.enum([
  "ACTIVE",
  "INACTIVE",
  "ERROR",
  "SYNCING"
]);
export type ConnectionStatus = z.infer<typeof ConnectionStatusSchema>;

export const ConnectionTypeSchema = z.enum([
  "OAUTH",
  "API_KEY",
  "WEBHOOK",
  "CUSTOM"
]);
export type ConnectionType = z.infer<typeof ConnectionTypeSchema>;

export const ControlEvidenceStatusEnumSchema = z.enum([
  "NOT_STARTED",
  "IN_PROGRESS",
  "COMPLETE",
  "NOT_APPLICABLE"
]);
export type ControlEvidenceStatusEnum = z.infer<typeof ControlEvidenceStatusEnumSchema>;

export const DeploymentLogStatusSchema = z.enum([
  "INFO",
  "WARNING",
  "ERROR",
  "SUCCESS"
]);
export type DeploymentLogStatus = z.infer<typeof DeploymentLogStatusSchema>;

export const DeploymentStatusSchema = z.enum([
  "PENDING",
  "IN_PROGRESS",
  "SUCCESS",
  "FAILED",
  "CANCELLED"
]);
export type DeploymentStatus = z.infer<typeof DeploymentStatusSchema>;

export const EvidenceReviewStatusSchema = z.enum([
  "PENDING",
  "APPROVED",
  "REJECTED",
  "NEEDS_REVISION"
]);
export type EvidenceReviewStatus = z.infer<typeof EvidenceReviewStatusSchema>;

export const ExportStatusSchema = z.enum([
  "PENDING",
  "IN_PROGRESS",
  "COMPLETED",
  "FAILED"
]);
export type ExportStatus = z.infer<typeof ExportStatusSchema>;

export const FeedbackSourceSchema = z.enum([
  "WIDGET",
  "API",
  "EXTENSION",
  "INTERNAL"
]);
export type FeedbackSource = z.infer<typeof FeedbackSourceSchema>;

export const FeedbackStatusSchema = z.enum([
  "NEW",
  "REVIEWED",
  "RESOLVED",
  "DISMISSED"
]);
export type FeedbackStatus = z.infer<typeof FeedbackStatusSchema>;

export const FeedbackTypeSchema = z.enum([
  "THUMBS_UP",
  "THUMBS_DOWN",
  "COMMENT",
  "SUGGESTION",
  "BUG_REPORT"
]);
export type FeedbackType = z.infer<typeof FeedbackTypeSchema>;

export const GapPrioritySchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH",
  "CRITICAL"
]);
export type GapPriority = z.infer<typeof GapPrioritySchema>;

export const GapStatusSchema = z.enum([
  "OPEN",
  "IN_PROGRESS",
  "RESOLVED",
  "DISMISSED"
]);
export type GapStatus = z.infer<typeof GapStatusSchema>;

export const GitOperationStatusSchema = z.enum([
  "PENDING",
  "IN_PROGRESS",
  "SUCCESS",
  "FAILED"
]);
export type GitOperationStatus = z.infer<typeof GitOperationStatusSchema>;

export const GitSyncStatusSchema = z.enum([
  "SYNCED",
  "PENDING",
  "ERROR",
  "DISABLED"
]);
export type GitSyncStatus = z.infer<typeof GitSyncStatusSchema>;

export const HealthStatusSchema = z.enum([
  "HEALTHY",
  "DEGRADED",
  "DOWN",
  "UNKNOWN"
]);
export type HealthStatus = z.infer<typeof HealthStatusSchema>;

export const IntegrationTypeSchema = z.enum([
  "NOTION",
  "CONFLUENCE",
  "GOOGLE_DRIVE",
  "GITHUB",
  "ZENDESK",
  "SLACK",
  "JIRA",
  "CUSTOM"
]);
export type IntegrationType = z.infer<typeof IntegrationTypeSchema>;

export const MessageRoleSchema = z.enum([
  "USER",
  "ASSISTANT",
  "SYSTEM"
]);
export type MessageRole = z.infer<typeof MessageRoleSchema>;

export const PropertyTypeSchema = z.enum([
  "TEXT",
  "NUMBER",
  "DATE",
  "SELECT",
  "MULTI_SELECT",
  "BOOLEAN",
  "URL",
  "EMAIL"
]);
export type PropertyType = z.infer<typeof PropertyTypeSchema>;

export const RenderStatusSchema = z.enum([
  "PENDING",
  "RENDERING",
  "COMPLETED",
  "FAILED"
]);
export type RenderStatus = z.infer<typeof RenderStatusSchema>;

export const ReplayChatStatusSchema = z.enum([
  "ACTIVE",
  "ARCHIVED",
  "DELETED"
]);
export type ReplayChatStatus = z.infer<typeof ReplayChatStatusSchema>;

export const ReplaySessionModeSchema = z.enum([
  "GUIDED",
  "EXPLORATORY"
]);
export type ReplaySessionMode = z.infer<typeof ReplaySessionModeSchema>;

export const ReplaySessionStatusSchema = z.enum([
  "ACTIVE",
  "COMPLETED",
  "FAILED",
  "CANCELLED"
]);
export type ReplaySessionStatus = z.infer<typeof ReplaySessionStatusSchema>;

export const ReviewStatusSchema = z.enum([
  "PENDING",
  "APPROVED",
  "REJECTED",
  "CHANGES_REQUESTED"
]);
export type ReviewStatus = z.infer<typeof ReviewStatusSchema>;

export const SiteStatusSchema = z.enum([
  "ACTIVE",
  "INACTIVE",
  "MAINTENANCE",
  "DELETED"
]);
export type SiteStatus = z.infer<typeof SiteStatusSchema>;

export const SourceStatusSchema = z.enum([
  "PENDING",
  "PROCESSING",
  "READY",
  "ERROR",
  "DELETED"
]);
export type SourceStatus = z.infer<typeof SourceStatusSchema>;

export const SourceTypeSchema = z.enum([
  "FILE",
  "URL",
  "CODE_REPOSITORY",
  "NOTION",
  "CONFLUENCE",
  "GOOGLE_DRIVE",
  "ZENDESK",
  "MANUAL"
]);
export type SourceType = z.infer<typeof SourceTypeSchema>;

export const TemplateTypeSchema = z.enum([
  "GUIDED",
  "STATIC_SCREENSHOT",
  "WORKFLOW",
  "DOCUMENT",
  "POLICY",
  "API",
  "CONTAINER"
]);
export type TemplateType = z.infer<typeof TemplateTypeSchema>;

export const TicketPlatformSchema = z.enum([
  "JIRA",
  "LINEAR",
  "GITHUB",
  "ASANA",
  "CUSTOM"
]);
export type TicketPlatform = z.infer<typeof TicketPlatformSchema>;

export const PopulationTypeSchema = z.enum([
  "EMPLOYEES",
  "TERMINATED_EMPLOYEES",
  "NEW_HIRES",
  "CONTRACTORS",
  "USERS",
  "PRIVILEGED_USERS",
  "ASSETS",
  "VENDORS",
  "CHANGES",
  "INCIDENTS",
  "VISITORS",
  "DEVICES",
  "SERVERS",
  "REPOSITORIES",
  "TICKETS"
]);
export type PopulationType = z.infer<typeof PopulationTypeSchema>;

export const PopulationSourceTypeSchema = z.enum([
  "MANUAL_UPLOAD"
]);
export type PopulationSourceType = z.infer<typeof PopulationSourceTypeSchema>;

export const SampleItemStatusSchema = z.enum([
  "PENDING",
  "EVIDENCE_COLLECTED",
  "PASSED",
  "FAILED",
  "EXCEPTION"
]);
export type SampleItemStatus = z.infer<typeof SampleItemStatusSchema>;

export const SamplingMethodSchema = z.enum([
  "RANDOM",
  "FIXED_COUNT",
  "FIXED_PERCENT",
  "STRATIFIED",
  "JUDGMENTAL",
  "ALL"
]);
export type SamplingMethod = z.infer<typeof SamplingMethodSchema>;

export const PublisherTypeSchema = z.enum([
  "INDIVIDUAL",
  "ORGANIZATION"
]);
export type PublisherType = z.infer<typeof PublisherTypeSchema>;

export const LicenseTypeSchema = z.enum([
  "MIT",
  "CC_BY",
  "PROPRIETARY"
]);
export type LicenseType = z.infer<typeof LicenseTypeSchema>;

export const VerificationBadgeSchema = z.enum([
  "COMMUNITY",
  "PARTNER",
  "AUDITOR_VERIFIED",
  "OFFICIAL"
]);
export type VerificationBadge = z.infer<typeof VerificationBadgeSchema>;

export const SubtaskSourceSchema = z.enum([
  "SAMPLE_ITEM",
  "TEMPLATE_DEFINITION",
  "MANUAL"
]);
export type SubtaskSource = z.infer<typeof SubtaskSourceSchema>;

export const EvidenceFrequencySchema = z.enum([
  "ONCE",
  "MONTHLY",
  "QUARTERLY",
  "SEMI_ANNUAL",
  "ANNUAL"
]);
export type EvidenceFrequency = z.infer<typeof EvidenceFrequencySchema>;

export const ApprovalStatusSchema = z.enum([
  "PENDING",
  "APPROVED",
  "REJECTED",
  "NEEDS_REVIEW"
]);
export type ApprovalStatus = z.infer<typeof ApprovalStatusSchema>;

export const BugReportStatusSchema = z.enum([
  "OPEN",
  "IN_PROGRESS",
  "RESOLVED",
  "CLOSED",
  "WONT_FIX"
]);
export type BugReportStatus = z.infer<typeof BugReportStatusSchema>;

export const BugReportPrioritySchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH",
  "CRITICAL"
]);
export type BugReportPriority = z.infer<typeof BugReportPrioritySchema>;

export const WorkflowExecutionFailedTypeSchema = z.enum([
  "LOGIN_EXPIRED",
  "VALIDATION_FAILED",
  "SELECTOR_FAILED",
  "UNKNOWN"
]);
export type WorkflowExecutionFailedType = z.infer<typeof WorkflowExecutionFailedTypeSchema>;

export const LabelColorSchema = z.enum([
  "GREY",
  "DARK_GREY",
  "PURPLE",
  "TEAL",
  "GREEN",
  "YELLOW",
  "ORANGE",
  "PINK",
  "RED"
]);
export type LabelColor = z.infer<typeof LabelColorSchema>;

export const ActionConnectionTypeSchema = z.enum([
  "Primary",
  "Alternative",
  "Back"
]);
export type ActionConnectionType = z.infer<typeof ActionConnectionTypeSchema>;

export const AnnouncementSeveritySchema = z.enum([
  "INFO",
  "WARNING",
  "CRITICAL"
]);
export type AnnouncementSeverity = z.infer<typeof AnnouncementSeveritySchema>;

export const AnnouncementTargetSchema = z.enum([
  "ALL",
  "PLAN",
  "ORGANIZATION"
]);
export type AnnouncementTarget = z.infer<typeof AnnouncementTargetSchema>;

export const ClaimDispositionSchema = z.enum([
  "CREATE_TEST",
  "LINK_EXISTING",
  "DISMISS"
]);
export type ClaimDisposition = z.infer<typeof ClaimDispositionSchema>;

export const ClaimSourceSchema = z.enum([
  "POLICY",
  "TSC_GAP"
]);
export type ClaimSource = z.infer<typeof ClaimSourceSchema>;

export const CommentStatusSchema = z.enum([
  "OPEN",
  "IN_PROGRESS",
  "RESOLVED",
  "DISMISSED",
  "IMPLEMENTED"
]);
export type CommentStatus = z.infer<typeof CommentStatusSchema>;

export const CommentVisibilitySchema = z.enum([
  "PRIVATE",
  "WORKSPACE",
  "PUBLIC"
]);
export type CommentVisibility = z.infer<typeof CommentVisibilitySchema>;

export const DeploymentModeSchema = z.enum([
  "STATIC",
  "DYNAMIC"
]);
export type DeploymentMode = z.infer<typeof DeploymentModeSchema>;

export const DeploymentVisibilitySchema = z.enum([
  "PUBLIC",
  "PRIVATE",
  "ORGANIZATION"
]);
export type DeploymentVisibility = z.infer<typeof DeploymentVisibilitySchema>;

export const GitOperationTypeSchema = z.enum([
  "PUSH",
  "PULL",
  "FETCH",
  "MERGE",
  "COMMIT",
  "CREATE_BRANCH",
  "SWITCH_BRANCH",
  "CREATE_TAG"
]);
export type GitOperationType = z.infer<typeof GitOperationTypeSchema>;

export const ImplementationStatusSchema = z.enum([
  "IMPLEMENTED",
  "UNIMPLEMENTED",
  "PARTIAL",
  "ERROR",
  "EXCEPTION"
]);
export type ImplementationStatus = z.infer<typeof ImplementationStatusSchema>;

export const IntegrationCategorySchema = z.enum([
  "Ticketing",
  "KnowledgeBase",
  "Communication",
  "DocumentationExport",
  "Other"
]);
export type IntegrationCategory = z.infer<typeof IntegrationCategorySchema>;

export const PrioritySchema = z.enum([
  "LOW",
  "MEDIUM",
  "HIGH"
]);
export type Priority = z.infer<typeof PrioritySchema>;

export const SiteModeSchema = z.enum([
  "PUBLIC",
  "PRIVATE"
]);
export type SiteMode = z.infer<typeof SiteModeSchema>;

export const SyncOperationSchema = z.enum([
  "IMPORT",
  "EXPORT",
  "TEST",
  "VALIDATE"
]);
export type SyncOperation = z.infer<typeof SyncOperationSchema>;

export const SyncStatusSchema = z.enum([
  "SUCCESS",
  "PARTIAL",
  "FAILED",
  "CANCELLED"
]);
export type SyncStatus = z.infer<typeof SyncStatusSchema>;

export const TaskStatusSchema = z.enum([
  "OPEN",
  "ASSIGNED",
  "IN_PROGRESS",
  "IN_REVIEW",
  "BLOCKED",
  "RESOLVED",
  "DISMISSED"
]);
export type TaskStatus = z.infer<typeof TaskStatusSchema>;

